import { render, staticRenderFns } from "./IdentificationDocumentFinancialSponsorForm.vue?vue&type=template&id=0e560468&scoped=true&"
import script from "./IdentificationDocumentFinancialSponsorForm.vue?vue&type=script&lang=ts&"
export * from "./IdentificationDocumentFinancialSponsorForm.vue?vue&type=script&lang=ts&"
import style0 from "./IdentificationDocumentFinancialSponsorForm.vue?vue&type=style&index=0&id=0e560468&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e560468",
  null
  
)

export default component.exports